// extracted by mini-css-extract-plugin
module.exports = {"SuggestionContainer":"appointments__ClinicianNameInput__SuggestionContainer"};